import { Badge, FormLabel, FormLabelProps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IndicatorProps {
  hasPendingChanges: boolean;
}

export function PendingChangesIndicator({ hasPendingChanges }: IndicatorProps) {
  const { t } = useTranslation();

  if (!hasPendingChanges) return null;

  return (
    <Badge
      color="articleManagement.accent"
      fontSize="2xs"
      textTransform="none"
      variant="subtle"
    >
      {t('form.notSaved')}
    </Badge>
  );
}

interface LabelProps extends FormLabelProps, IndicatorProps {}

export function PendingChangesLabel(props: LabelProps) {
  const { children, hasPendingChanges, ...labelProps } = props;

  return (
    <FormLabel {...labelProps} alignItems="center" display="flex" gap={2}>
      {children}
      <PendingChangesIndicator hasPendingChanges={hasPendingChanges} />
    </FormLabel>
  );
}
